<div class="enin-backdrop">
  <nk-layout-centered>
    <h3>You are now logged out</h3>
    <p>You can login again <a routerLink="/login">here</a></p>
  </nk-layout-centered>
</div>
